import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";
import { Card, Text } from "nectar-ui";

export const CardDivider = styled.span<NectarTheme>`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    background-color: ${theme.colors.gray300};
    align-self: center;
    border-radius: 8px;
    height: 1px;
    margin-bottom: ${theme.spacings.lg};
  `}
`;

export const InfoCard = styled(Card)<NectarTheme>`
  ${({ _theme }) => css`
    display: flex;
    flex-direction: column;
    max-width: 919px;

    > div:last-child {
      margin-bottom: 0;
    }
  `}
`;

export const NormalText = styled(Text)<NectarTheme & { shouldContain?: boolean }>`
  ${({ theme, shouldContain }) => css`
    font-size: 16px;
    margin-bottom: 0;
    width: fit-content;

    ${shouldContain &&
    css`
      width: 80%;
      ${theme.breakpoints.sm} {
        width: 40%;
      }
    `}
  `}
`;

export const InfoRow = styled.div<NectarTheme>`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacings.lg};
    row-gap: ${theme.spacings.xs};
    display: flex;
    flex-direction: column;

    ${theme.breakpoints.sm} {
      row-gap: 0;
      display: grid;
      grid-template-columns: 225px 1fr;
      column-gap: ${theme.spacings.lg};
    }

    & p {
      word-break: break-word;
    }
  `}
`;

export const ListCard = styled(Card)<NectarTheme & { noDivider?: boolean }>`
  ${({ theme, noDivider = false }) => css`
    border-color: ${theme.colors.gray300};
    padding: ${theme.spacings.lg};
    margin-top: ${theme.spacings.xs};
    max-width: 2113px;

    ${!noDivider &&
    css`
      & > div::after {
        grid-area: divider;
        display: block;
        content: "";
        margin: ${theme.spacings.lg} 0;
        border-radius: 8px;
        height: 1px;
        background-color: ${theme.colors.gray300};
      }

      & > div:last-child::after {
        content: none;
      }
    `}
  `}
`;

export const DateText = styled(Text)<NectarTheme>`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 140%;
    color: ${theme.colors.gray900};
    grid-area: date;
  `}
`;
